<template>

  <div>

    <md-dialog :md-active.sync="isPictureModalShowing">
      <md-dialog-content>
        <h3>Pictures</h3>
        <view-image :key="p" :src="p" v-for="p in photos"/>
      </md-dialog-content>
      <md-dialog-actions>
        <download-pictures-button :pics="photos"/>
        <md-button class="md-primary" @click="isPictureModalShowing = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-card class="searchPanel">
       <md-card-expand>
        <md-card-expand-content>
      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-30 md-small-size-100">

            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-field>
                  <label>Load</label>
                  <md-input v-model="searchRequest.loadIdFrom" @keyup.enter="doSearch"/>
                </md-field>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <md-field>
                  <label>To</label>
                  <md-input v-model="searchRequest.loadIdTo" @keyup.enter="doSearch"/>
                </md-field>
              </div>
            </div>

            <auto-complete-master-data-multiple-select
                label="BOL Status"
                :prepared-options="bolStatusOptions"
                v-model="searchRequest.bolStatus"
            />
          </div>
          <div class="md-layout-item md-size-30 md-small-size-100">

            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <datepicker v-model="searchRequest.etaAssignedStart">
                  <label>ETA Assigned</label>
                </datepicker>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <datepicker v-model="searchRequest.etaAssignedEnd">
                  <label>To</label>
                </datepicker>
              </div>
            </div>

            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <datepicker v-model="searchRequest.pickUpStart">
                  <label>Pickup Date</label>
                </datepicker>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <datepicker v-model="searchRequest.pickUpEnd">
                  <label>To</label>
                </datepicker>
              </div>
            </div>

            <md-checkbox v-model="filterUpdatedToSapFail" v-if="getRole.isAcnIT">
              Show only update to SAP failed
            </md-checkbox>

          </div>
          <div class="md-layout-item md-size-40 md-small-size-100">

            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <auto-complete-master-data-multiple-select
                    group="Hauler"
                    label="Hauler"
                    v-model="searchRequest.haulers">
                </auto-complete-master-data-multiple-select>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <auto-complete-master-data-multiple-select
                    group="ProblemCode"
                    label="Problem"
                    v-model="searchRequest.problems">
                </auto-complete-master-data-multiple-select>
              </div>
            </div>

            <div class="md-layout md-gutter">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <auto-complete-master-data-multiple-select
                    :prepared-options="getDriverGroupOptionsForUser"
                    v-model="searchRequest.driverGroups"
                    label="Driver Group">
                </auto-complete-master-data-multiple-select>
              </div>

              <div class="md-layout-item md-size-50 md-small-size-100">
                <auto-complete-master-data-multiple-select
                        :preparedOptions="drivers"
                        label="Driver"
                        v-model="searchRequest.drivers"
                        display-type="idOnly"
                        >
                </auto-complete-master-data-multiple-select>
              </div>

              <div class="md-layout-item md-size-50 md-small-size-100">

                <auto-complete-search-store-multiple-select
                    multiple="true"
                    label="Store"
                    :join-end-outlets="true"
                    v-model="searchRequest.storeIds">
                </auto-complete-search-store-multiple-select>

              </div>
            </div>

          </div>
        </div>
      </md-card-content>
       </md-card-expand-content>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-60 md-small-size-100">
            <calling-api path="/api/w/billOfLoads/save" v-if="getPermission.loads.edit">
              <md-button class="md-raised" :disabled="!canConfirm" @click="doConfirm">Confirm</md-button>
              <md-button class="md-raised" :disabled="!canUnConfirm" @click="doUnConfirm">UnConfirm</md-button>
              <md-button class="md-raised" :disabled="!canChange" @click="doChange">Change</md-button>
              <md-button class="md-raised" :disabled="!canSave" @click="doSave">Save</md-button>
              <md-button class="md-raised" :disabled="!canCopy" @click="doCopy">Copy</md-button>
              <!--<md-button class="md-raised" :disabled="!canNew" @click="doNew">New</md-button>-->
            </calling-api>
          </div>
          <div class="md-layout-item md-size-20 md-small-size-100">
            <md-card-actions>
              <calling-api path="/api/w/excel/generate">
                <md-button v-if="getPermission.loads.edit" class="md-raised" @click="toggleUpload">Upload</md-button>
                <md-button v-if="bols.length > 0" class="md-raised" @click="doDownloadExcel">Download</md-button>
                <input type="file" class="md-hide" id="upload-file" accept=".xls,.xlsx" @change="handleFileSelected"/>
              </calling-api>
            </md-card-actions>
          </div>
          <div class="md-layout-item md-size-20 md-small-size-100">
            <md-card-actions>
              <calling-api path="/api/w/billOfLoads">
                <md-button @click="doSearch" class="md-primary md-raised">Search</md-button>
                <md-button @click="clearSearch" class="md-raised">Clear</md-button>
              </calling-api>
               <md-card-expand-trigger>
            <md-button class="md-icon-button" id="expand-button">
              <md-icon>keyboard_arrow_down</md-icon>
            </md-button>
          </md-card-expand-trigger>
        </md-card-actions>
           
          </div>
        </div>
      </md-card-content>
      </md-card-expand>
    </md-card>
    <br/>


    <pagination :items="getBolsToDisplay">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                  <tr>
                    <th class="header-cell w2-5" v-if="getPermission.loads.edit">
                      <md-checkbox v-model="allItemsSelected" @change="handleAllItemSelectedChanged">
                      </md-checkbox>
                    </th>
                    <th class="header-cell w4">
                      Confirmed
                    </th>
                    <th class="header-cell w8">
                      <sort :sort.sync="sort" field="loadIdUsed">
                        Load Id
                      </sort>
                    </th>
                    <th class="header-cell w8">Store</th>
                    <th class="header-cell w8">ETA Plan</th>
                    <th class="header-cell w8">ETA Assigned</th>
                    <th class="header-cell w8">
                      <sort :sort.sync="sort" field="rawPickUpDate">
                        Pick-up Date
                      </sort>
                    </th>
                    <th class="header-cell w6">Pick-up Time</th>
                    <th class="header-cell w6">BOL Status</th>
                    <th class="header-cell w6">BOL</th>
                    <th class="header-cell w6">Bale Picked</th>
                    <th class="header-cell w6">Bale Left</th>
                    <th class="header-cell w6">Problem</th>
                    <th class="header-cell w6">BOL Photo Link</th>
                    <th class="header-cell w6">BOL Weight</th>
                    <th class="header-cell w6">Weight Unit</th>
                    <th class="header-cell w6">Weight/Bale</th>
                    <th class="header-cell w6">Scale Ticket</th>
                    <th class="header-cell w6">Load Weight</th>
                    <th class="header-cell w8">Driver</th>
                    <th class="header-cell w6">Haulier</th>
                    <th class="header-cell w6">Driver Group</th>
                    <th class="header-cell w6">Create Person</th>
                    <th class="header-cell w6">Create Date</th>
                    <th class="header-cell w6">Create Time</th>
                    <th class="header-cell w6">Confirmed Person</th>
                    <th class="header-cell w6">Confirmed Date</th>
                    <th class="header-cell w6">Confirmed Time</th>
                    <th class="header-cell w6">Change Person</th>
                    <th class="header-cell w6">Change Date</th>
                    <th class="header-cell w6">Change Time</th>
                    <th v-if="getRole.isAcnIT" class="header-cell w6">Updated to SAP</th>
                    <th v-if="getRole.isAcnIT" class="header-cell w6">Updated to SAP Date</th>
                    <th v-if="getRole.isAcnIT" class="header-cell w15">Updated to SAP message</th>
                  </tr>
                  </thead>
                </table>
              </div>
              <div class="table-body" @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                  <tr :key="item.key" class="" v-for="item in pageItems">
                    <td class="body-cell w2-5" v-if="getPermission.loads.edit">
                      <md-checkbox :disabled="!!item.confirmedBy" v-model="item.selected"/>
                    </td>
                    <td class="body-cell w4">
                      <md-checkbox disabled v-model="item.confirmed"/>
                    </td>
                    <td class="body-cell w8">
                      <template v-if="item.isNew">
                        <auto-complete-select
                            :options="loadIds"
                            v-model="item.loadIdUsed">
                        </auto-complete-select>
                      </template>
                      <template v-else>
                        {{item.loadIdUsed}}
                      </template>

                    </td>
                    <td class="body-cell w8">
                      <template v-if="canEditCommonField(item) || item.isNew">
                        <auto-complete-search-store-multiple-select
                            v-model="item.storeId">
                        </auto-complete-search-store-multiple-select>
                      </template>
                      <template v-else>
                        {{item.storeId}}
                      </template>
                    </td>

                    <td class="body-cell w8">
                      <template v-if="canEditCommonField(item) || item.isNew">
                        <md-field>
                          <md-input v-model="item.etaString"/>
                        </md-field>
                        <span class="md-error" v-if="isDateNotValid(item.etaString)">Invalid format</span>
                      </template>
                      <template v-else>
                        {{item.etaString}}
                      </template>
                    </td>

                    <td class="body-cell w8">
                      <template v-if="canEditCommonField(item) || item.isNew">
                        <md-field>
                          <md-input v-model="item.etaAssignedString"/>
                        </md-field>
                        <span class="md-error" v-if="isDateNotValid(item.etaAssignedString)">Invalid format</span>
                      </template>
                      <template v-else>
                        {{item.etaAssignedString}}
                      </template>
                    </td>

                    <td class="body-cell w8">
                      <template v-if="item.isChanging || item.isNew">
                        <md-field>
                          <md-input v-model="item.pickUpDateString"/>
                        </md-field>
                        <span class="md-error" v-if="isDateNotValid(item.pickUpDateString)">Invalid format</span>
                      </template>
                      <template v-else>
                        {{item.pickUpDateString}}
                      </template>
                    </td>
                    <td class="body-cell w6">
                      <template v-if="item.isChanging || item.isNew">
                        <md-field>
                          <md-input v-model="item.pickUpTimeString"/>
                        </md-field>
                        <span class="md-error" v-if="isTimeNotValid(item.pickUpTimeString)">Invalid format</span>
                      </template>
                      <template v-else>
                        {{item.pickUpTimeString}}
                      </template>
                    </td>
                    <td class="body-cell w6">
                      {{item.bolConfirmStatus}}
                    </td>
                    <td class="body-cell w6">
                      <template v-if="item.isNew">
                        <md-field>
                          <md-input v-model="item.id"/>
                        </md-field>
                      </template>
                      <template v-else>
                        {{item.id}}
                      </template>
                    </td>
                    <td class="body-cell w6">
                      <template v-if="item.isChanging || item.isNew">
                        <md-field>
                          <md-input type="number" v-model="item.balePicked"/>
                        </md-field>
                      </template>
                      <template v-else>
                        {{item.balePicked}}
                      </template>
                    </td>
                    <td class="body-cell w6">
                      <template v-if="item.isChanging || item.isNew">
                        <md-field>
                          <md-input type="number" v-model="item.baleLeft"/>
                        </md-field>
                      </template>
                      <template v-else>
                        {{item.baleLeft}}
                      </template>
                    </td>

                    <td class="body-cell w6">
                      <template v-if="item.isChanging || item.isNew">
                        <master-data-select group="ProblemCode" v-model="item.problemCode"/>
                      </template>
                      <master-data-display v-else group="ProblemCode" :tag-id="item.problemCode"/>
                    </td>
                    <td class="body-cell w6">
                      <template v-if="item.photos.length > 0">
                        <a href="" @click.prevent="toggleItemPhoto(item.photos)">{{item.photos.length}} photos</a>
                      </template>
                      <template v-else>
                        <span>0 photos</span>
                      </template>
                    </td>

                    <td class="body-cell w6">
                      {{item.bolWeight | withComma}}
                    </td>

                    <td class="body-cell w6">
                      {{item.weightUnit}}
                    </td>

                    <td class="body-cell w6">
                      {{getWeightDividedByBale(item) | withComma}}
                    </td>

                    <td class="body-cell w6">
                      {{item.scaleTicket}}
                    </td>

                    <td class="body-cell w6">
                      <template v-if="item.load">
                        {{item.load.totalWeight | withComma}}
                      </template>
                    </td>

                    <td class="body-cell w8">
                      {{item.driverId}}
                    </td>

                    <td class="body-cell w6">
                      {{item.haulerId}}
                    </td>

                    <td class="body-cell w6">
                      {{item.driverGroup}}
                    </td>

                    <td class="body-cell w6">
                      {{item.createdBy}}
                    </td>
                    <td class="body-cell w6">
                      {{item.createdAt|date}}
                    </td>
                    <td class="body-cell w6">
                      {{item.createdAt|time}}
                    </td>
                    <td class="body-cell w6">
                      {{item.confirmedBy}}
                    </td>
                    <td class="body-cell w6">
                      {{item.confirmedAt|date}}
                    </td>
                    <td class="body-cell w6">
                      {{item.confirmedAt|time}}
                    </td>
                    <td class="body-cell w6">
                      {{item.updatedBy}}
                    </td>
                    <td class="body-cell w6">
                      {{item.updatedAt|date}}
                    </td>
                    <td class="body-cell w6">
                      {{item.updatedAt|time}}
                    </td>
                    <td v-if="getRole.isAcnIT" class="body-cell w6">{{item.updatedToSap}}</td>
                    <td v-if="getRole.isAcnIT" class="body-cell w6">{{item.updatedToSapAt | date}} {{item.updatedToSapAt | time}}</td>
                    <td v-if="getRole.isAcnIT" class="body-cell w15">{{item.updatedToSapMessage}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
  </div>

</template>

<style scoped>
</style>

<script>
  import { mapGetters } from 'vuex';
  import parseXls from '../utils/parseXls';
  import validateTime from '../utils/validate-time';
  import validateDate from '../utils/validate-date';
  import toGenerateExcelRequest from '../utils/excel';
  import dateFormat from '../utils/dateFormat';
  //import api from "../api";
  import { newAPIPost } from '../api';
  import { sortList } from '../utils/sort';

  const bolStatusOptions = [
    { id: 'C', name: 'BOL Completed' },
    { id: 'Y', name: 'BOL Confirmed' },
    { id: 'D', name: 'Dry-Run' },
    { id: 'Z', name: 'Dry-Run Confirmed' },
    { id: '1', name: 'BOL Manual' },
    { id: '9', name: 'BOL Manual Confirmed' },
  ];

  function getInitSearchRequest() {
    return {
      bolStatus: ['C', 'D', '1'],
      etaAssignedStart: null,
      etaAssignedEnd: null,
      pickUpStart: null,
      pickUpEnd: null,
      loadIdFrom: null,
      loadIdTo: null,
      haulers: [],
      problems: [],
      driverGroups: [],
      storeIds: [],
      drivers:[],
    };
  }

  export default {
    data: () => ({
      searchRequest: getInitSearchRequest(),
      bols: [],
      bolStatusOptions,
      drivers: null,
      isPictureModalShowing: false,
      photos: [],
      loads: [],
      loadIds: [],
      allItemsSelected: false,
      sort: {
        field: `loadIdUsed`,
        ascending: true,
      },
      filterUpdatedToSapFail: false,
    }),
    computed: {
      ...mapGetters([
        'getRole',
        'getMasterDataName',
        'getBillOfLoads',
        'getPermission',
        'getDriverGroupOptionsForUser',
      ]),
      getBolsToDisplay() {
        if (this.filterUpdatedToSapFail) {
          return _(sortList(this.bols, this.sort)).filter(it => it.updatedToSap === false);
        }
        return sortList(this.bols, this.sort);
      },
      getSelectedItems() {
        return _(this.getBolsToDisplay).filter(it => it.selected === true);
      },
      canConfirm() {
        if (this.getSelectedItems.length === 0) {
          return false;
        }
        if (_(this.getSelectedItems).find(it => it.isNew === true)) {
          return false;
        }
        if (_(this.getSelectedItems).find(it => _(it).lookup('load.confirmed') !== true)) {
          return false;
        }
        const confirmStatus = ['C', '1'];
        return !_(this.getSelectedItems)
          .find(it => !_(confirmStatus).contains(it.bolConfirmStatus) || it.confirmed);
      },
      canUnConfirm() {
        if (this.getSelectedItems.length === 0) {
          return false;
        }
        if (_(this.getSelectedItems).find(it => it.isNew === true)) {
          return false;
        }
        if (_(this.getSelectedItems).find(it => !!it.confirmedBy)) {
          return false;
        }
        const confirmStatus = ['C', '1'];
        return !_(this.getSelectedItems)
          .find(it => !_(confirmStatus).contains(it.bolConfirmStatus) || !it.confirmed);
      },
      canChange() {
        if (this.getSelectedItems.length === 0) {
          return false;
        }
        if (_(this.getSelectedItems).find(it => it.isNew === true)) {
          return false;
        }
        const confirmStatus = ['C', '1'];
        return !_(this.getSelectedItems)
          .find(it => !_(confirmStatus).contains(it.bolConfirmStatus));
      },
      canSave() {
        if (this.getSelectedItems.length === 0) {
          return false;
        }
        return true;
      },
      canCopy() {
        if (this.getSelectedItems.length !== 1) {
          return false;
        }
        if (_(this.getSelectedItems).find(it => it.isNew === true)) {
          return false;
        }
        return this.getSelectedItems.length === 1;
      },
      canNew() {
        if (_(this.bols).find(it => it.isNew)) {
          return false;
        }
        return true;
      },
    },
    watch: {
      getBillOfLoads(val) {
        this.updateCachedBolsFromApi(val);
      },
    },
    mounted() {
      this.$el.querySelector('#expand-button')
        .click();
      this.updateCachedBolsFromApi(this.getBillOfLoads);

      const cachedSearchRequest = this.$store.state.billOfLoad.searchRequest;
      if (cachedSearchRequest && !_(cachedSearchRequest).isEmpty()) {
        this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
      }

      this.$store.dispatch('getUsersByCategory', { category: 'A' })
        .then((res) => {
          this.drivers = res;
        });

        
      //api.post('/api/w/loads', { loadStatus: ['C', 'X', 'Y', '1', '9'] }).then((loads) => {
      newAPIPost('/api/w/loads', { loadStatus: ['C', 'X', 'Y', '1', '9'] }).then((loads) => {
        this.loadIds = _(loads).map(it => it.loadIdAssigned);
        this.loads = loads;
      });
    },
    methods: {
      getWeightDividedByBale(item) {
        const weight = item.bolWeight;
        if (!weight || weight === 0) {
          return 0;
        }
        const { balePicked } = item;
        if (!balePicked || balePicked === 0) {
          return 0;
        }
        return (weight / balePicked).toFixed(3);
      },
      handleScroll(e) {
        $(this.$el.querySelector('.table-header')).offset({ left: -1 * (e.target.scrollLeft - $('.outer-container').offset().left) });
      },
      isDateNotValid(value) {
        if (value) {
          const valid = validateDate(value);
          return !valid;
        }
        return false;
      },
      isTimeNotValid(value) {
        if (value) {
          const valid = validateTime(value);
          return !valid;
        }
        return false;
      },
      updateCachedBolsFromApi(newBillOfLoads) {
        const clone = JSON.parse(JSON.stringify(newBillOfLoads));
        _(clone).each((it) => {
          const photos = _.without([it.balesLeftPic, it.bolPic], null);
          it.key = `${it.id}+${it.loadIdUsed}`;
          it.photos = photos;
          it.confirmed = it.confirmed === true;
          it.isChanging = false;
          it.selected = false;
          it.rawPickUpDate = it.pickUpDate;
          it.pickUpDateString = dateFormat.date(it.pickUpDate);
          it.pickUpTimeString = dateFormat.time(it.pickUpDate);
          it.etaString = dateFormat.date(it.eta);
          it.etaAssignedString = dateFormat.date(it.etaAssigned);
        });
        this.bols = clone;
      },
      doSearch() {

        console.log(this.searchRequest.pickUpEnd);
        console.log(moment(this.searchRequest.pickUpEnd).toDate());

        this.$store.dispatch('loadBillOfLoads', this.searchRequest).then(this.updateTableHeight);
      },
      clearSearch() {
        _(this.$el.querySelectorAll('.searchPanel .md-field button.md-input-action.md-clear')).each((it) => {
          it.click();
        });
        this.$nextTick(() => {
          this.searchRequest = getInitSearchRequest();
        });
      },
      toggleUpload() {
        this.$el.querySelector('#upload-file').click();
      },
      canEditCommonField(item) {
        return item.isChanging && item.bolConfirmStatus !== 'C';
      },
      handleFileSelected(e) {
        const { files } = e.target;
        if (files && files[0]) {
          parseXls(files[0]).then((bols) => {
            bols.shift();

            this.bols = _(bols).chain().filter(it => !_(it).isEmpty())
              .map((bol) => {
                console.log(bol);
                return {
                  key: `${Math.random() * 99999999}`,
                  isNew: true,
                  selected: true,
                  storeId: `W0${bol[0]}`,
                  loadIdUsed: bol[1],
                  etaString: dateFormat.date(dateFormat.tryDateFromExcel(bol[2])),
                  etaAssignedString: dateFormat.date(dateFormat.tryDateFromExcel(bol[2])),
                  pickUpDateString: dateFormat.date(dateFormat.tryDateFromExcel(bol[3])),
                  pickUpTimeString: bol[4],
                  driverId: bol[5],
                  haulerId: bol[6],
                  id: bol[7],
                  balePicked: bol[8],
                  baleLeft: bol[9],
                  bolWeight: bol[10],
                  loadWeight: bol[11],
                  weightUnit: bol[12],
                  problemCode: bol[13],
                  scaleTicket: bol[14],
                  scheduleId: null,
                  bolConfirmStatus: bol[15],
                  remark: null,
                  confirmed: false,
                  photos: [],
                };
              })
              .value();


            this.$el.querySelector('#upload-file').value = '';
          });
        }
      },
      toggleItemPhoto(photos) {
        this.photos = photos;
        this.isPictureModalShowing = true;
      },
      doDownloadExcel() {
        const request = toGenerateExcelRequest(
          this.$el.querySelector('.data-table-container .inner-container'),
          'BOL.xls',
          1,
        );

        request.heads = _(request.heads).take(30);
        request.rows = _(this.getBolsToDisplay).map(item => [
          item.confirmed,
          item.loadIdUsed,
          item.storeId,
          dateFormat.date(item.etaDate),
          dateFormat.date(item.etaAssigned),
          dateFormat.date(item.pickUpDate),
          dateFormat.time(item.pickUpDate),
          item.bolConfirmStatus,
          item.id,
          item.balePicked,
          item.baleLeft,
          this.getMasterDataName('ProblemCode', item.problemCode),
          `${item.photos.length} photos`,
          item.bolWeight,
          item.weightUnit,
          this.getWeightDividedByBale(item),
          item.scaleTicket,
          _(item).lookup('load.totalWeight'),
          item.driverId,
          item.haulerId,
          item.driverGroup,
          item.createdBy,
          dateFormat.date(item.createdAt),
          dateFormat.time(item.createdAt),
          item.confirmedBy,
          dateFormat.date(item.confirmedAt),
          dateFormat.time(item.confirmedAt),
          item.updatedBy,
          dateFormat.date(item.updatedAt),
          dateFormat.time(item.updatedAt),
        ]);

        this.$store.dispatch('generateExcel', request).then((res) => {
          window.open(res.url, 'blank');
        });
      },
      doConfirm() {
        _(this.getSelectedItems).each((it) => {
          it.confirmed = true;

          _(this.bols).chain().filter(bol => bol.loadIdUsed === it.loadIdUsed).each((bol) => {
            bol.confirmed = true;
            bol.selected = true;
          });
        });
      },
      doUnConfirm() {
        _(this.getSelectedItems).each((it) => {
          it.confirmed = false;
        });
      },
      doChange() {
        _(this.getSelectedItems).each((it) => {
          it.isChanging = true;
        });
      },
      doCopy() {
        this.bols = _(this.getSelectedItems).map((it) => {
          const bol = JSON.parse(JSON.stringify(it));
          bol.bolConfirmStatus = '1';
          bol.isNew = true;
          bol.scheduleId = null;
          bol.photos = [];
          bol.createdAt = null;
          bol.createdBy = null;
          return bol;
        });
      },
      doNew() {
        this.bols = [
          {
            isNew: true,
            selected: true,
            storeId: null,
            loadIdUsed: null,
            etaString: null,
            etaAssignedString: null,
            pickUpDateString: null,
            pickUpTimeString: null,
            driverId: null,
            haulerId: null,
            id: null,
            balePicked: null,
            baleLeft: null,
            bolWeight: null,
            loadWeight: null,
            weightUnit: null,
            problemCode: null,
            scaleTicket: null,
            scheduleId: null,
            bolConfirmStatus: null,
            remark: null,
            confirmed: false,
            photos: [],
          }
        ];
      },
      doSave() {
        const combineDateAndTime = (date, time) => {
          if (!date) {
            return null;
          }
          const dateString = moment(date).format('YYYYMMDD');
          const timeString = time || '00:00';
          return moment(dateString + timeString, 'YYYYMMDDHHmm').toDate();
        };

        const requestBillOfLoads = _(this.getSelectedItems).map(it => ({
          isNew: it.isNew,
          storeId: it.storeId,
          loadIdUsed: it.loadIdUsed,
          eta: combineDateAndTime(it.etaString),
          etaAssigned: combineDateAndTime(it.etaAssignedString),
          pickUpDate: combineDateAndTime(it.pickUpDateString, it.pickUpTimeString),
          driverId: it.driverId,
          haulerId: it.haulerId,
          id: it.id,
          balePicked: it.balePicked,
          baleLeft: it.baleLeft,
          bolWeight: it.bolWeight,
          loadWeight: it.loadWeight,
          weightUnit: it.weightUnit,
          problemCode: it.problemCode,
          scaleTicket: it.scaleTicket,
          scheduleId: it.scheduleId,
          bolConfirmStatus: it.bolConfirmStatus,
          remark: it.remark,
          confirmed: it.confirmed,
          load: _(this.loads).find(load => load.loadIdAssigned === it.loadIdUsed) || it.load,
        }));

        console.log(JSON.stringify(requestBillOfLoads));
        const invalidItems = this.checkSaveRequest(requestBillOfLoads);

        if (invalidItems.length > 0) {
          return;
        }

        this.$store.dispatch('saveBillOfLoads', { billOfLoads: requestBillOfLoads }).then(() => {
          this.doSearch();
        });
      },
      checkSaveRequest(requestBillOfLoads) {
        return _(requestBillOfLoads).filter((it) => {
          const errs = [];
          if (!it.loadIdUsed) {
            errs.push('Load Id is required.');
          }
          if (!it.storeId) {
            errs.push('Store is required.');
          }

          const pickupDateMoment = moment(it.pickUpDate);

          if (it.load) {
            const loadDeliveryMoment = moment(it.load.deliveryDate);
            const loadDeliveryDiffPickup = Math.abs(pickupDateMoment.diff(loadDeliveryMoment, 'days'));
            if (pickupDateMoment.isAfter(loadDeliveryMoment) || loadDeliveryDiffPickup > 3) {
              errs.push(`Pickup date cannot later or earlier for more than 3 days to load delivery date.(load delivery date : ${loadDeliveryMoment.format('MM/DD/YYYY')})`);
            }
          }


          const momentEta = moment(it.eta);
          const etaPickupDiff = Math.abs(momentEta.diff(pickupDateMoment, 'days'));
          if (etaPickupDiff > 7) {
            errs.push('Pickup date cannot different from eta more than 7 days.');
          }

          const momentEtaAssigned = moment(it.etaAssigned);
          const etaAssignedPickupDiff = Math.abs(momentEtaAssigned.diff(pickupDateMoment, 'days'));
          console.log(`pickupDateMoment=${pickupDateMoment.format('YYYY/MM/DD')}`);
          console.log(`momentEta=${momentEta.format('YYYY/MM/DD')}`);
          console.log(`etaPickupDiff=${etaPickupDiff}`);
          console.log(`momentEtaAssigned=${momentEtaAssigned.format('YYYY/MM/DD')}`);
          console.log(`etaAssignedPickupDiff=${etaAssignedPickupDiff}`);
          if (etaAssignedPickupDiff > 7) {
            errs.push('Pickup date cannot different from eta assigned more than 7 days.');
          }

          if (it.bolConfirmStatus !== 'D' && (!it.balePicked || it.balePicked < 1 || it.balePicked > 99)) {
            errs.push('Bales picked must between 1~99.');
          }

          if (!it.driverId) {
            errs.push('Driver is required.');
          }

          if (errs.length > 0) {
            window.alert(_(errs).uniq().join("\r\n"));
          }
          return errs.length > 0;
        });
      },
      handleAllItemSelectedChanged() {
        if (this.allItemsSelected === true) {
          _(this.bols).chain()
            .filter(it => !it.confirmedBy)
            .each(it => {
              it.selected = true;
            })
        } else {
          _(this.bols).chain()
            .each(it => {
              it.selected = false;
            })
        }

      },
    },
  };

</script>
